import { request } from './request.js';
import request_storage from "./request_storage.js"

export default {
	request_storage,
	getCurPage(){
	    let pages = getCurrentPages();
	    let curPage = pages[pages.length-1];
	    return curPage
	},
	
	async apps(page, len) {
		return request("/open/apps", {page, len})
	},
	async getAppById(id) {
		return request("/open/get_app_by_id", {id})
	},
	async parseConfig(data) {
		return request("/open/parse_config", {data}, "application/json")
	},
	async updateAppInfo(data) {
		return request("/open/update_app_info", data, "application/json")
	},
	async updateAppIcon(url, id) {
		return upload("/open/update_app_icon", url, {id});
	},
	async ad_switch(id, s) {
		return request("/open/ad_switch", {id, s});
	},
	async queryApp(text) {
		return request("/open/query_app", {text});
	},
	async queryAppInfo(package_name) {
		return request("/open/query_app_info", {package_name});
	},
	async getChangeLogs(id) {
		return request("/open/change_logs", {id});
	},
	async getAppVersions(id) {
		return request("/open/get_app_versions", {id});
	},
	async saveAppVersionConfig(data) {
		return request("/open/save_app_version_config", data, "application/json")
	},
	async checkLogin() {
		return request("/open/check_login")
	},
	async login(username, password) {
		return request("/open/login", {username, password});
	},
	async updateAdId(package_name, key, value) {
		return request("/open/update_app_apid", {package_name, key, value});
	},
	async updateTopOnId(package_name, key, value) {
		return request("/open/update_topon_apid", {package_name, key, value});
	},
	async getAppVersionChangeLogs(id, version) {
		return request("/open/get_app_version_change_logs", {id, version});
	},
	async saveMoreGame(form) {
		return request("/android/save_more_game", form, "application/json")
	},
	async getMoreGame(page, len) {
		return request("/android/get_more_game_list", {page, len})
	},
	async delMoreGame(id) {
		return request("/android/del_more_game", {id})
	},
	async getMoreGameCount() {
		return request("/android/get_more_game_count")
	},
	async addCallbackApp(package_name) {
		return request("/android/add_callback_app", { package_name })
	},
	async getCallbackApps() {
		return request("/android/get_callback_apps")
	},
	async deleteCallbackApp(id) {
		return request("/android/delete_callback_app", {id})
	},
	async saveCallbackApp(body) {
		return request("/android/save_callback_app", body, "application/json")
	},
	async getCallbackStat(id, date) {
		return request("/android/get_callback_stat", {id, date})
	},
	async getCallbackHistory(id, page, len) {
		return request("/android/get_callback_history", {id, page, len})
	},
	async batch_update_native_click_rate(rate) {
		return request("/open/batch_update_native_click_rate", {rate})
	},
	async create_app(package_name, name) {
		return request(`/open/create_app?package_name=${package_name}&name=${name}&company_id=1`)
	},
	async getSrcIds(package_name) {
		return request(`/open/get_src_id?package_name=${package_name}`)
	},
	async saveSrcId(package_name, adv_id, src_id) {
		return request(`/open/add_src_id?package_name=${package_name}&adv_id=${adv_id}&src_id=${src_id}`)
	}
}